import {
  DataTableColumnBadgeProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '@/components/data-table-builder/data-table.types';
import { DocSubmissionRepository } from '@/store/doc-submission-state/doc-submission-state.repository';

interface IgetDocSubmissionDataTableStructureProps {
  store: DocSubmissionRepository;
  rowActions?: DataTableRowActions;
  createAction: () => void;
  enableServerActions?: boolean;
  serverQuery?: any;
}

export const getDocSubmissionDataTableStructure = ({
  store,
  rowActions,
  enableServerActions,
  serverQuery,
  createAction,
}: IgetDocSubmissionDataTableStructureProps): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.docSubmission.table.id',
    accessorKey: 'id',
    variant: DataTableColumnVariant.TEXT,
  };
  const nomColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.docSubmission.table.nom',
    accessorKey: 'nom',
    variant: DataTableColumnVariant.TEXT,
  };
  const categorieActiviteColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.docSubmission.table.typeDossier',
    accessorKey: 'typeDossier.libelle',
    variant: DataTableColumnVariant.TEXT,
  };
  const validationDateRequiredColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'settings.docSubmission.table.validation.label',
    accessorKey: 'validationDateRequired',
    variant: DataTableColumnVariant.BADGE,
    props: {
      getSeverity: value => {
        return value ? 'success' : 'danger';
      },
    },
    renderAs: (value: boolean) => {
      return {
        value: value ? 'settings.docSubmission.table.validation.yes' : 'settings.docSubmission.table.validation.no',
      };
    },
  };

  return {
    singular: 'settings.docSubmission.table.singular',
    plural: 'settings.docSubmission.table.plural',
    columns: [idColumn, nomColumn, categorieActiviteColumn, validationDateRequiredColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: row => {
      store.set('serverState', {
        nom: row.nom,
        typeDossierId: row.typeDossier.id,
      });
      store.set('dto', {
        nom: row.nom,
        typeDossierId: row.typeDossier.id,
      });
      store.set('docSubmissionCategorySelected', {
        name: row.typeDossier.libelle,
        code: row.typeDossier.id,
      });
    },
    createAction,
    rowActions,
    enableServerActions,
    serverQuery,
  };
};
